<script setup>
import { MapboxGeocoder } from '@studiometa/vue-mapbox-gl';
import { ref } from 'vue';

// MaboxGeocoder stylesheet needs to be imported manually.
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css';

const control = ref();
const emit = defineEmits(['flyto']);
const props = defineProps(['labels']);

function test(result) {
	emit('flyto', result.result.center);
}
</script>

<template>
	<MapboxGeocoder
		class="map-mobile-search"
		access-token="pk.eyJ1IjoiYmVudG9kYXkiLCJhIjoiY2xlNzh4Y3lhMDM1bzN1bWdrYTFmMWN5bCJ9.fvgJSulDCj8AeuQ-pb8CYg"
		:placeholder="props.labels.find"
		@mb-created="(instance) => (control = instance)"
		@mb-result="(result) => test(result)"
	/>
</template>
